import { ThemeType } from 'types/publishedAssets';
import { TranslatableField } from 'types/supportedLanguages';
import { buildPublicUrlPrefix } from './publicUrlRule';

export const determineHomepageFromCurrentUrl = (organization: string) => {
  if (!organization) {
    return null;
  }
  if (typeof window === 'undefined') {
    return null;
  }
  if (organization.includes('favicon.ico')) {
    return null;
  }
  // this is only called on 404 page so we can allow redirect back to homepage
  const homepageUrl = `${window.location.origin}/${organization}/`;
  return homepageUrl;
};

export const determineHomepage = (domain: string, locale?: string, canonicalHostname?: string | null) => {
  if (!canonicalHostname && !globalThis?.process?.env?.NEXT_PUBLIC_HOST_URL) {
    // this will only happen in 404 page as process.env is not available in the custom 404 page.
    return determineHomepageFromCurrentUrl(domain);
  }

  const prefix = buildPublicUrlPrefix(domain, canonicalHostname);
  if (locale) {
    return `${prefix}/${locale}/`;
  }
  return `${prefix}/`;
};

export const determineProjectPage = (params: {
  domain?: string;
  locale?: string;
  project?: string;
  projectHubEnabled?: boolean;
  canonicalHostname?: string | null;
}) => {
  const { domain, locale, project, projectHubEnabled, canonicalHostname } = params;
  if (!domain || !locale || !project || projectHubEnabled === false) {
    return '';
  }
  return `${buildPublicUrlPrefix(domain, canonicalHostname)}/${locale}/projects/${project}`;
};

export const determineSafeUrl = (url: string) => {
  let safeUrl = url;
  if (!url.toLowerCase().startsWith('http')) {
    // if user did not include https:// we need to add it for them otherwise link will break.
    safeUrl = `https://${url}`;
  }
  return safeUrl;
};

export const determineLogoRedirectUrl = (theme?: ThemeType): string =>
  theme?.alternativeHomepageUrl || theme?.logoRedirectUrl || '';

export const determineThemeName = (
  theme?: ThemeType,
  translateField?: (field: TranslatableField, fallbackOverride?: string) => string,
): string => {
  // TODO: this may need to be changed based on V1 / V2 (result should be organization name)
  if (!theme) return '';
  if (typeof theme.name === 'string') {
    return theme.name;
  }
  return translateField?.(theme.name, theme?.defaultLanguage) || '';
};
